// extracted by mini-css-extract-plugin
module.exports = {"container":"AnnotationList__container--nrm28TLi-R","empty-message-box":"AnnotationList__empty-message-box--2fk710hCh9","empty-message":"AnnotationList__empty-message--3EGRhTvlJU"};